import {API_URL_USERS} from '../constants';

export const apiBaseAddKid = {
  baseUrl: API_URL_USERS,
  endpoints: {
    newTeen: '/family/v2/new-teen',
    newSwitchTeen: '/family/v1/new-switch-teen',
    addTeenWithInvitation: '/family/v2/add-new-teen-via-invitation',
  },
};
